var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
if (Shopify.country == "US") {
  Shopify.money_format = "${{amount_no_decimals}}";
} else if(Shopify.country == "GB") {
  Shopify.money_format = "£{{amount_no_decimals}}";
} else {
  Shopify.money_format = "{{amount_no_decimals}}€";
}
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
          options && typeof options.onSuccess === 'function'
              ? options.onSuccess
              : function () {},
      onFailure:
          options && typeof options.onFailure === 'function'
              ? options.onFailure
              : function () {},
      always:
          options && typeof options.always === 'function'
              ? options.always
              : function () {},
    });
  }

  async updateAttribute(attributes, options) {
    const formData = {
      attributes: attributes,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
          options && typeof options.onSuccess === 'function'
              ? options.onSuccess
              : function () {},
      onFailure:
          options && typeof options.onFailure === 'function'
              ? options.onFailure
              : function () {},
      always:
          options && typeof options.always === 'function'
              ? options.always
              : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
        options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
                'To add a new item both properties: ID & QUANTITY are required',
                item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
                'To update an existing item, both properties: KEY & QUANTITY are required',
                item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
        // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
          nextRequest.formData,
          nextRequest.action,
          nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
          `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
        .then(function (response) {
          if (response.ok) return response.json();
          throw Error(response.statusText);
        })
        .then(function (cart) {
          try {
            options.onSuccess();
          } catch (e) {
            console.error(
                'Error executing onSuccess callback from postShopify',
                e,
            );
          }

          return {cart};
        })
        .catch(function (error) {
          self.handleErrors(error);

          try {
            options.onFailure();
          } catch (e) {
            console.error(
                'Error executing onFailure callback from postShopify',
                e,
            );
          }

          return {err: error};
        })
        .finally(function () {
          try {
            options.always();
          } catch (e) {
            console.error('Error executing always callback from postShopify', e);
          }

          // Handle next request if there are any in the queue.
          if (self.requestsQueue.length) {
            const nextRequest = self.requestsQueue.pop();
            return self.postShopify(nextRequest.formData, nextRequest.action);
          }
        });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();

        this.removeEvent = new Event('remove', {bubbles: true});
        this.addEventListener('click', (event) => {
          event.preventDefault();
          this.dispatchEvent(this.removeEvent);
        });
      }
    },
);

customElements.define(
    'cart-items',
    class CartItems extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartNotification: 'cart-notification',
          variantSelects: 'variant-selects',
        };

        this.selectors = selectors;
        this.cartNotifications = document.querySelectorAll(
            this.selectors.cartNotification,
        );
        this.variantSelects = document.querySelectorAll(
            this.selectors.variantSelects,
        );

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]'),
        ).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0,
        );

        this.debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));

        this.addEventListener('remove', (event) => {
          this.updateQuantity(
              event.target.dataset.index,
              0,
              document.activeElement.getAttribute('name'),
              (event.target.dataset != null && event.target.dataset.removeGift != null) ? this.removeGift.bind(this) : "",
          );
        });
      }

      removeGift() {
      }

      onChange(event) {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute('name'),
        );
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-total-price]',
          },
          {
            id: 'drawer-cart-upsell',
            section:
                document.getElementById('drawer-cart-upsell') != null
                    ? document.getElementById('drawer-cart-upsell').dataset.id
                    : null,
            selector: '[data-upsell-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-discounted',
            section:
                document.getElementById('drawer-cart-upsell-discounted') != null
                    ? document.getElementById('drawer-cart-upsell-discounted').dataset.id
                    : null,
            selector: '[data-upsell-discounted-cart-drawer]',
          }
        ];
      }

      updateQuantity(line, quantity, name, callback) {
        this.enableLoading(line);

        localStorage.setItem('productUpdated', true);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(window.root_url+'/cart/change', {...fetchConfig(), ...{body}})
            .then((response) => {
              return response.text();
            })
            .then((state) => {

              //
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartFooter = document.getElementById('main-cart-footer');

              if (cartFooter)
                cartFooter.classList.toggle(
                    'is-empty',
                    parsedState.item_count === 0,
                );

              this.cartNotifications.forEach((section) => {
                section.updateItemsCount(parsedState.item_count);
              });

              this.variantSelects.forEach((section) => {
                section.reset();
              });

              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector,
                    );
                  }
                }
              });

              const lineItem = document.getElementById(`CartItem-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`))
                lineItem.querySelector(`[name="${name}"]`).focus();
              this.disableLoading(line);

              if (callback && typeof callback == 'function') {
                callback();
              };
            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
              this.disableLoading(line);
            });
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      enableLoading(line) {
        document
            .getElementById('main-cart-items')
            .classList.add('cart__items--disabled');
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
            (overlay) => overlay.classList.remove('hidden'),
        );
        this.querySelector(`#CartItem-${line}`).classList.add('updating');
        document.activeElement.blur();
      }

      disableLoading(line) {
        document
            .getElementById('main-cart-items')
            .classList.remove('cart__items--disabled');
        if (this.querySelector(`#CartItem-${line}`) != null) {
          this.querySelector(`#CartItem-${line}`).classList.remove('updating');
        }
      }
    },
);


customElements.define(
    'cart-upsell-dynamic',
    class CartUpsellDynamic extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartNotification: 'cart-notification',
          addUpsellDynamic: '[data-add-upsell-dynamic]',
          addUpsellDynamicTarget: 'data-add-upsell-dynamic-target',
          addUpsellDynamicProduct: 'data-add-upsell-dynamic-product',
          addUpsellDynamicQuantity: 'data-add-upsell-dynamic-quantity',
          addUpsellDynamicSellingPlan: 'data-add-upsell-dynamic-selling-plan',
        };

        this.selectors = selectors;
        this.cartNotifications = document.querySelectorAll(
            this.selectors.cartNotification,
        );

        this.addUpsellDynamics = document.querySelectorAll(
            this.selectors.addUpsellDynamic,
        );

        this.addUpsellDynamics.forEach((addUpsellDynamic) => {
          addUpsellDynamic.addEventListener('click', (event) => {
            this.addUpsellDynamic(
                event.target.dataset.addUpsellDynamicTarget,
                event.target.dataset.addUpsellDynamicProduct,
                event.target.dataset.addUpsellDynamicQuantity,
                (event.target.dataset.addUpsellDynamicSellingPlan != undefined) ? event.target.dataset.addUpsellDynamicSellingPlan: '',
            );
          });
        });

      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-total-price]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-discounted',
            section:
                document.getElementById('drawer-cart-upsell-discounted') != null
                    ? document.getElementById('drawer-cart-upsell-discounted').dataset.id
                    : null,
            selector: '[data-upsell-discounted-cart-drawer]',
          }
        ];
      }

      async addUpsellDynamic(oldProduct, newProduct, quantity, selling_plan) {

        localStorage.setItem('upsellAdded', true);

        const body = JSON.stringify({
          id: oldProduct,
          quantity: 0
        });

        // await this.updateItemById(oldProduct, 0);

        var sections = this.getSectionsToRender().map((section) => section.section);
        var sections_url = window.location.pathname;
        await this.addItem(newProduct, quantity, selling_plan, sections, sections_url);

      }

      async addItem(variantId, quantity, selling_plan) {
        const result = await fetch(window.root_url+"/cart/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            selling_plan: selling_plan
          })
        }).then((response) => {
          return response.text();
        })
            .then((state) => {

              //
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);

              this.cartNotifications.forEach((section) => {
                var q = section.getItemsCount();
                section.updateItemsCount(parseInt(q) + parseInt(quantity));
              });

              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector,
                    );
                  }
                }
              });

              const lineItem = document.getElementById(`CartItem-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`))
                lineItem.querySelector(`[name="${name}"]`).focus();
            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
            });
      }

      async init() {
        await fetch(window.root_url+'/?sections=cart-drawer-v2', {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              const doc = new DOMParser().parseFromString(
                  response['cart-drawer-v2'],
                  'text/html',
              );
              var contentUpdated = doc.querySelector('#drawer-cart-upsell-dynamic').innerHTML;
              this.innerHTML = contentUpdated;

            })
            .catch((error) => {
              console.error('Error:', error);
            });
      }

      async updateItem(data) {
        const result = await fetch(window.root_url+"/cart/change", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        });
      }

      updateItemById(lineItemId, newQuantity, newProperties = {}) {
        return this.updateItem({
          id: lineItemId,
          quantity: newQuantity,
          properties: newProperties
        });
      }


      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

    },
);

customElements.define(
    'cart-quantity-input',
    class CartQuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true});

        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this)),
        );
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus'
            ? this.input.stepUp()
            : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }
    },
);

customElements.define(
    'cart-notification',
    class CartNotification extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartCount: '[data-cart-count]',
        };
        this.selectors = selectors;
        this.cartNotification = this.querySelector(this.selectors.cartCount);
      }

      updateItemsCount(itemsCount) {
        if (!this.cartNotification) return;

        this.cartNotification.innerHTML = itemsCount;
      }

      getItemsCount() {
        if (!this.cartNotification) return;
        return this.cartNotification.innerHTML;
      }
    },
);

customElements.define(
    'cart-progress-bar-gift',
    class progressbarGift extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          treshold : "[data-progress-treshold]",
          tresholdData : "progressTreshold",
          price : "[data-progress-price]",
          priceFree : "[data-progress-price-free]",
          priceData : "[data-progress-treshold-price]",
          progressBar : "[data-progress-bar]",
          addToCart : "[data-add-progress-bar-gift]",
          productVariantID : "addProgressBarGiftProduct",
        };

        this.selectors = selectors;

        this.progressTreshold = this.querySelector(this.selectors.treshold);
        this.progressTresholdData = this.querySelector(this.selectors.treshold).dataset[this.selectors.tresholdData];
        this.progressPrice = this.querySelector(this.selectors.price);
        this.progressPriceFree = this.querySelector(this.selectors.priceFree);
        this.progressPriceData = this.querySelector(this.selectors.priceData);
        this.progressBar = this.querySelector(this.selectors.progressBar);
        this.productVariantID = this.querySelector(this.selectors.addToCart).dataset[this.selectors.productVariantID];
        this.addToCart = this.querySelector(this.selectors.addToCart);

        this.addToCart.addEventListener('click', (event) => {
          this.addToCart.disabled = true;
          this.addItem(this.productVariantID);
        });

        // this.init();
      }

      async init() {

        const cart = await cartManager.getCart();

        var ifGiftIsInCart = false;
        for (let index = 0; index < cart.items.length; index++) {
          if (cart.items[index].variant_id == this.productVariantID) {
            ifGiftIsInCart = true;
          }
        }

        if (ifGiftIsInCart) {
          this.classList.add('hide');
        } else {
          this.classList.remove('hide');
        }

        var price = (parseInt(this.progressTresholdData) - cart.items_subtotal_price);
        (price > 0) ? price : price = 0;

        this.progressPriceData.innerHTML =  Shopify.formatMoney(price);

        var pourcentage = (cart.items_subtotal_price * 100 / parseInt(this.progressTresholdData));

        if (pourcentage < 100) {
          this.progressBar.style.width = pourcentage + "%";
          this.progressPrice.classList.remove('hidden');
          this.progressPriceFree.classList.add('hidden');
        } else {
          this.progressBar.style.width = "100%";
          this.progressPrice.classList.add('hidden');
          this.progressPriceFree.classList.remove('hidden');
          if (!ifGiftIsInCart && localStorage.getItem('giftAddedAuto') == null) {
            this.addItem(this.productVariantID);
            localStorage.setItem('giftAddedAuto', this.productVariantID);
          }
        }
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-total-price]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-discounted',
            section:
                document.getElementById('drawer-cart-upsell-discounted') != null
                    ? document.getElementById('drawer-cart-upsell-discounted').dataset.id
                    : null,
            selector: '[data-upsell-discounted-cart-drawer]',
          }
        ];
      }

      async addItem(variantId) {
        const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              "_is_gift": true
            }
          })
        }).then((response) => {
          return response.text();

        })
            .then((state) => {

              //
              this.addToCart.disabled = false;
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);

              this.cartNotifications.forEach((section) => {
                var q = section.getItemsCount();
                section.updateItemsCount(parseInt(q) + parseInt(quantity));
              });

              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector,
                    );
                  }
                }
              });

            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
            });
      }
    });


customElements.define(
    'cart-drawer',
    class CartDrawer extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartOpen: '[data-cart-drawer-open]',
          cartClose: '[data-cart-drawer-close]',
          cartDrawer: 'cart-drawer-v2',
          cartOverlay: 'cart-overlay',
          body: 'body',
          cartNotification: 'cart-notification',
          cartUpsellDynamic: 'cart-upsell-dynamic',
          cartNote: '[data-cart-drawer-note]',
        };

        this.selectors = selectors;
        this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
        this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
        this.body = document.getElementsByTagName(this.selectors.body);
        this.cartNotifications = document.querySelectorAll(
            this.selectors.cartNotification,
        );
        this.cartUpsellDynamic = document.querySelector(
            this.selectors.cartUpsellDynamic,
        );
        this.cartNote = document.querySelector(
            this.selectors.cartNote,
        );

        this.cartDrawer.addEventListener(
            'keyup',
            (evt) => evt.code === 'Escape' && this.close(),
        );

        document
            .querySelectorAll(this.selectors.cartOpen)
            .forEach((cartOpen) =>
                cartOpen.addEventListener('click', this.handleCartUpdates.bind(this), false),
            );

        this.init();
      }

      init() {
        // Detect cart interactions
        this.httpInterceptor(
            [
              '/cart/add',
              '/cart/add',
              '/cart/change',
              // '/cart/update',
              '/cart/clear',
            ],
            this.handleCartUpdates.bind(this),
        );
      }

      open() {
        this.cartDrawer.classList.add('animate', 'active');
        this.cartOverlay.classList.add('animate', 'active');
        this.body[0].style.overflowY = "hidden";
      }

      close() {
        this.cartDrawer.classList.remove('active');
        this.cartOverlay.classList.remove('active');
        this.body[0].style.overflowY = "scroll";

        if (window.location.href.indexOf('/cart') > -1) {
          window.location.href = "/"
        }
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-total-price]',
          },
          {
            id: 'drawer-cart-upsell-discounted',
            section:
                document.getElementById('drawer-cart-upsell-discounted') != null
                    ? document.getElementById('drawer-cart-upsell-discounted').dataset.id
                    : null,
            selector: '[data-upsell-discounted-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell',
            section:
                document.getElementById('drawer-cart-upsell') != null
                    ? document.getElementById('drawer-cart-upsell').dataset.id
                    : null,
            selector: '[data-upsell-cart-drawer]',
          }
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      async renderContents(refreshContentsAllow) {
        await fetch(window.root_url+'/?sections=cart-drawer-v2', {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              // const doc = new DOMParser().parseFromString(
              //   response['cart-drawer-v2'],
              //   'text/html',
              // );
              // var contentUpdated = doc.querySelector('#cart-drawer-v2').innerHTML;
              // this.cartDrawer.innerHTML = contentUpdated;

              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  if(document.getElementById(section.id) != null && document.querySelector(section.selector) != null){
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);
                    if (elementToReplace != null) {
                      elementToReplace.innerHTML = this.getSectionInnerHTML(
                          response["cart-drawer-v2"],
                          section.selector,
                      );
                    }
                  }
                }
              });

              document
                  .querySelectorAll(this.selectors.cartClose)
                  .forEach((cartClose) =>
                      cartClose.addEventListener('click', this.close.bind(this)),
                  );

              if(document.querySelector('#cart-progressbar-rewards') != null) {
                this.cartProgressBarSampless = document.querySelector('#cart-progressbar-rewards');
                this.cartProgressBarSampless.init();
              }
              if(document.querySelector('#cart-drawer-shipping-estimate') != null) {
                this.cartProgressBarSampless = document.querySelector('#cart-drawer-shipping-estimate');
                this.cartProgressBarSampless.init();
              }

            })
            .catch((error) => {
              console.error('Error:', error);
            });

        this.open();
        this.initCheckoutButton();
      }

      initCheckoutButton() {
        var checkoutButton = this.cartDrawer.querySelector('[data-checkout-cart-drawer]');
        checkoutButton.addEventListener('click', function(e) {
          window.location = Shopify.routes.root + "checkout";
        });
      }

      async handleCartUpdates(res, url) {
        if (res != undefined && res.target != undefined && res.target) {
          res.preventDefault();
        }
        const shopifyCart = await cartManager.getCart();
        this.cartNotifications.forEach((section) => {
          section.updateItemsCount(shopifyCart.item_count);
        });

        let refreshContentsAllow = true;

        if (localStorage.getItem('noteUpdated')) {
          localStorage.removeItem('noteUpdated');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('productUpdated')) {
          localStorage.removeItem('productUpdated');
          refreshContentsAllow = true;
        }
        if (localStorage.getItem('upsellAdded')) {
          localStorage.removeItem('upsellAdded');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('rewardAdded')) {
          localStorage.removeItem('rewardAdded');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('samplesAdded')) {
          localStorage.removeItem('samplesAdded');
          refreshContentsAllow = false;
        }

        if (refreshContentsAllow) {
          await this.renderContents(refreshContentsAllow);

          var found_gift_wrap = false;
          for (let index = 0; index < shopifyCart.items.length; index++) {
            if (shopifyCart.items[index].properties["_is_gift_wrap"]) {
              found_gift_wrap = true;
            }
          }
          if (shopifyCart.item_count != 0) {
            if (this.cartNote != null) {
              this.cartNote.classList.remove('hidden');
            }
          }
          if (shopifyCart.item_count == 1 && found_gift_wrap) {
            this.cartNote.classList.add('hidden');
            this.cartNote.querySelector('[data-gift-wrap-input]').click();
          }
          if (shopifyCart.item_count == 0) {
            this.cartNote.classList.add('hidden');
          }
        }

      }

      async httpInterceptor(urlmatchs, callback) {
        var responseMatchesAnyUrl = function (requestUrl, urls) {
          if (!Array.isArray(urls)) urls = [urls];

          for (const url of urls) {
            if (!requestUrl.includes(url)) continue;
            return true;
          }

          return false;
        };

        // Intercept fetch.
        const constantMock = window.fetch;
        window.fetch = function () {
          return new Promise((resolve, reject) => {
            constantMock
                .apply(this, arguments)
                .then(async (response) => {
                  try {
                    if (
                        responseMatchesAnyUrl(response.url, urlmatchs) &&
                        response.type != 'cors' &&
                        response.ok
                    ) {
                      let json = await response.clone().json();
                      if (typeof callback === 'function')
                        await callback(json, response.url);
                    }
                  } catch (err) {
                    console.error(
                        'Something went wrong while intercepting cart update',
                        err,
                    );
                  }
                  resolve(response);
                })
                .catch((error) => {
                  reject(error);
                });
          });
        };

        // Intercept Ajax.
        let send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
          this.addEventListener(
              'readystatechange',
              async function () {
                if (
                    responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
                    this.readyState === 4 &&
                    this.status == 200
                ) {
                  if (typeof callback === 'function')
                    await callback(JSON.parse(this.response), this.responseURL);
                }
              },
              false,
          );
          send.apply(this, arguments);
        };

        // TODO: Listen to HTML form submits.
        // Intercept HTML Forms.
        document.addEventListener(
            'submit',
            function (e) {
              // Valid the target.
              if (
                  !e.target ||
                  e.target.tagName.toLowerCase() !== 'form' ||
                  e.target.matches('[sz-no-block]')
              )
                return;
              // Validate the URL.
              var form = e.target;
              var submitButton = e.submitter;
              var actionUrl = new URL(form.action);
              var actionPath = actionUrl.pathname;
              if (!actionPath.includes('/cart')) return;

              e.preventDefault();
              this.cartDrawer = document.querySelector('cart-drawer');


              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              const formData = new FormData(form);
              config.body = formData;


              // Close quickadd popup
              var quickAdd = document.querySelector("[data-quickadd-popup]");
              if (quickAdd != undefined) quickAdd.style.display = "none";

              fetch(actionPath, config)
                  .then((response) => response.json())
                  .then(async function (response) {
                    if (response.status) {
                      return;
                    }

                    if (actionPath == "/cart/add") {

                    }

                    if (typeof callback === 'function')
                      await callback(undefined, response);
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {});
            }.bind(this),
        );
      }
    },
);

customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.trigger = document.querySelector('[data-note-trigger]');
        this.input = document.querySelector('[data-note-input]');
        this.checkbox = document.querySelector('#note_checkbox');
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleNote();
        });

        this.debouncedOnChange = debounce((event) => {
          if (this.checkbox.checked) {
            this.updateNote(this.input.value);
          }else{
            this.updateNote('');
          }
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
      }

      toggleNote() {
        if (this.classList.contains('active')) {
          this.classList.remove('active');
        } else {
          this.classList.add('active');
        }
      }

      updateNote(text) {
        this.enableLoadingNote();
        cartManager.updateNote(text, {
          onSuccess: this.disableLoadingNote.bind(this),
        });
        localStorage.setItem('noteUpdated', true);
      }

      enableLoadingNote() {
        this.querySelectorAll(`.loading-overlay`).forEach((overlay) =>
            overlay.classList.remove('hidden'),
        );
        this.classList.add('updating');
      }

      disableLoadingNote() {
        this.querySelectorAll(`.loading-overlay`).forEach((overlay) =>
            overlay.classList.add('hidden'),
        );
        this.classList.remove('updating');
      }
    },
);

customElements.define(
    'cart-gift-wrap',
    class CartGiftWrap extends HTMLElement {
      constructor() {
        super();

        this.input = document.querySelector('[data-gift-wrap-input]');
        this.variantId = document.querySelector('[data-gift-wrap-id]').dataset.giftWrapId;

        this.debouncedOnChange = debounce((event) => {
          this.updateAttribute(this.input.checked);
        }, 300);

        this.input.addEventListener('change', this.debouncedOnChange.bind(this));
      }

      async updateAttribute(value) {
        const cart = await cartManager.getCart();

        var hasAlreadyGiftWrap = false;
        for (let index = 0; index < cart.items.length; index++) {
          if (cart.items[index].properties["_is_gift_wrap"]) {
            hasAlreadyGiftWrap = true;
          }
        }

        if (value == true) {
          var cart_attribute = cart.attributes;
          cart_attribute["gift_wrap"] = true;
          if(!hasAlreadyGiftWrap && this.variantId != null) {
            await this.addItem(this.variantId, 1);
          }
        } else {
          var cart_attribute = cart.attributes;
          cart_attribute["gift_wrap"] = "";
          if(hasAlreadyGiftWrap && this.variantId != null) {
            await this.removeItem(this.variantId);
          }
        }

        this.enableLoadingNote();
        cartManager.updateAttribute(cart_attribute, {
          onSuccess: this.disableLoadingNote.bind(this),
        });
      }

      async addItem(variantId, quantity) {
        localStorage.setItem('productUpdated', true);

        const result = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: {
              '_is_gift_wrap': true
            }
          })
        }).then((response) => {
          return response.text();
        })
            .then((state) => {

            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
            });
      }

      async removeItem(variantId) {
        localStorage.setItem('productUpdated', true);

        const result = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 0
          })
        }).then((response) => {
          return response.text();
        })
            .then((state) => {
            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
            });
      }

      enableLoadingNote() {
        this.querySelectorAll(`.loading-overlay`).forEach((overlay) =>
            overlay.classList.remove('hidden'),
        );
        this.classList.add('updating');
      }

      disableLoadingNote() {
        this.querySelectorAll(`.loading-overlay`).forEach((overlay) =>
            overlay.classList.add('hidden'),
        );
        this.classList.remove('updating');
      }
    },
);




// Progress bar
customElements.define(
    'progressbar-rewards',
    class ProgressBarRewards extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          "progressSettings" : "[data-progressbar-rewards-settings]",
          "progressSettingsData" : "progressbarRewardsSettings",
          "progressCurrentMessage" : "[data-progressbar-rewards--current-message]",
          "progressNextMessage" : "[data-progressbar-rewards--next-message]",
          "progressImage" : "[data-progressbar-rewards--image]",
          "progressBarContainer" : "[data-progressbar-rewards--progress-bar-container]",
          "progressBar" : "[data-progressbar-rewards--progress-bar]",
          "progressThreshold" : "[data-progressbar-rewards--threshold]",
          "progressThresholdMarker" : "[data-progressbar-rewards--threshold-marker]",
        };

        this.selectors = selectors;

        this.init();
      }

      getCookieItemReward(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
      }

      setCookieItemReward(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      }

      deleteCookieItemReward(name) {
        this.setCookieItemReward(name, '', -1);
      }

      async init() {
        if(this.querySelector(this.selectors.progressSettings) != null) {
          let packSettingsData = JSON.parse(this.querySelector(this.selectors.progressSettings).dataset[this.selectors.progressSettingsData]);

          let progressCurrentMessage = this.querySelector(this.selectors.progressCurrentMessage);
          let progressNextMessage = this.querySelector(this.selectors.progressNextMessage);
          let progressImage = this.querySelector(this.selectors.progressImage);
          let progressBarContainer = this.querySelector(this.selectors.progressBarContainer);
          let progressBar = this.querySelector(this.selectors.progressBar);
          let progressThresholds = this.querySelectorAll(this.selectors.progressThreshold);
          let progressThresholdMarkers = this.querySelectorAll(this.selectors.progressThresholdMarker);

          let lastStepReach = false;

          const cart = await cartManager.getCart();

          var currentStep = null;
          var nextStep = null;
          for (let index = 0; index < packSettingsData.steps.length; index++) {
            if (cart.total_price >= parseInt(packSettingsData.steps[index].threshold)) {
              currentStep = packSettingsData.steps[index];
              nextStep = packSettingsData.steps[index + 1];
            }
          }

          // None step reach
          if (currentStep == null && nextStep == null) {
            nextStep = packSettingsData.steps[0];
          }

          // Last step reach
          if (currentStep != null && nextStep == null) {
            lastStepReach = true;
          }

          //set markers
          if (progressThresholdMarkers != null) {
            var markerWidth = progressBarContainer.offsetWidth / progressThresholdMarkers.length;
            var markerPosition = markerWidth / 4;
            progressThresholdMarkers.forEach(function callback(marker, index) {
              marker.style.left = (markerWidth * index) + markerPosition * (index + 1) + 'px';
            });
          }

          //If current step is product add the product
          if (currentStep != null && currentStep.type == "product") {
            var productIsAdded = false;
            if (this.getCookieItemReward('rewardIsAdded') == null) {
              for (let index = 0; index < cart.items.length; index++) {
                if (cart.items[index].properties != null) {
                  if ('_is_reward' in cart.items[index].properties) {
                    if (cart.items[index].properties["_reward_id"] == currentStep.id) {
                      productIsAdded = true;
                    }
                  }
                }
              }
            }

            if (!productIsAdded) {
              console.log("currentStep");
              console.log(currentStep);
              this.setCookieItemReward('rewardIsAdded', true, 0.1);

              var addReward = false;
              var rewardsAdded = [];
              if (this.getCookieItemReward('rewardsAdded') != null) {
                rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
              }

              if (rewardsAdded.length == 0) {
                addReward = true;
              } else {
                var findReward = false;
                for (let index = 0; index < rewardsAdded.length; index++) {
                  if(rewardsAdded[index].id == currentStep.id) {
                    findReward = true;
                  }
                }
                if (!findReward) {
                  addReward = true;
                }
              }


              if (addReward) {
                rewardsAdded.push({
                  variant_id: currentStep.variant_id,
                  threshold: currentStep.threshold,
                  id: currentStep.id
                })
                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 0.1);
                await this.addItem(currentStep.variant_id, 1, currentStep.threshold, currentStep.id);
              }
            }

            // check if oldsteps are added to cart
            var rewardsIDAdded = [];
            var missingRewards = [];
            if (this.getCookieItemReward('rewardsAdded') != null) {
              var rewardsisAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
            }

            if (rewardsisAdded != null) {
              for (let index = 0; index < rewardsisAdded.length; index++) {
                rewardsIDAdded.push(rewardsisAdded[index].id);
              }
            }

            console.log("rewardsIDAdded");
            console.log(rewardsIDAdded);

            for (let index = 0; index < packSettingsData.steps.length; index++) {
              if (cart.total_price >= parseInt(packSettingsData.steps[index].threshold)) {
                if (!rewardsIDAdded.includes(packSettingsData.steps[index].id)) {
                  if (packSettingsData.steps[index].type == "product") {
                    missingRewards.push(packSettingsData.steps[index]);
                  }
                }
              }
            }

            console.log("missingRewards");
            console.log(missingRewards);

            if (missingRewards.length != 0) {

              var missingRewardInfo = [];
              if (this.getCookieItemReward('rewardsAdded') != null) {
                missingRewardInfo = JSON.parse(this.getCookieItemReward('rewardsAdded'));
              }

              for (let index = 0; index < missingRewards.length; index++) {
                var missingReward = missingRewards[index];
                missingRewardInfo.push({
                  variant_id: missingReward.variant_id,
                  threshold: missingReward.threshold,
                  id: missingReward.id
                })
                this.setCookieItemReward('rewardsAdded', JSON.stringify(missingRewardInfo), 0.1);
                await this.addItem(missingReward.variant_id, 1, missingReward.threshold, missingReward.id);
              }
            }

          }
          const sczCartRewards = document.querySelector(".scz-cart-rewards");
          if (!lastStepReach) {
            var leftBeforeThreshold = '<span class="scz-cart-rewards__price-left">' + Shopify.formatMoney(parseInt(nextStep.threshold) - cart.total_price) + '</span>';
            var nextMessage = nextStep.before_message.replace('##left##', leftBeforeThreshold);
            var nextImage = nextStep.image;
            var nextTreshold = parseInt(nextStep.threshold);
            progressImage.src = nextImage;
            if (sczCartRewards.classList.contains("no_grid")){
              sczCartRewards.classList.remove("no_grid");
              progressImage.classList.remove("display_none");
            }
          } else {
            var nextMessage = currentStep.after_message;
            // var nextImage = currentStep.image;
            sczCartRewards.classList.add("no_grid");
            progressImage.classList.add("display_none");
            var nextTreshold = parseInt(currentStep.threshold);
          }


          // progressImage.style.display = "none";
          progressNextMessage.innerHTML = nextMessage;

          if (lastStepReach) {
            progressBar.style.width = "100%";
          } else {
            var percentage = (parseFloat(cart.total_price) * 100) / nextTreshold;
            var nextMarker = this.querySelector('[data-progressbar-rewards--threshold-marker="'+ nextTreshold.toString() +'"]');
            var nextMarkerPosition = parseFloat(nextMarker.style.left);
            progressBar.style.width = percentage *  nextMarkerPosition / 100 + "px";
          }

          if (progressThresholds != null) {
            progressThresholds.forEach(function callback(treshold, index) {
              if (treshold.dataset["progressbarRewards-Threshold"] <= cart.total_price) {
                treshold.classList.add('active');
              } else {
                treshold.classList.remove('active');
              }
            });
          }

          for (let index = 0; index < cart.items.length; index++) {
            if (cart.items[index].properties != null) {
              if ('_is_reward' in cart.items[index].properties) {
                if (parseInt(cart.items[index].properties["_reward_threshold"]) > cart.total_price) {
                  await this.updateItemById(cart.items[index].key, 0, cart.items[index].properties);
                }
              }
            }
          }

          if (cart.total_price == 0) {
            this.deleteCookieItemReward('rewardsAdded');
          }
        }
      }

      async addItem(variantId, quantity, threshold, id) {
        const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: {
              '_is_reward': true,
              '_reward_id': id,
              '_reward_threshold': threshold,
            }
          })
        }).then((response) => {
          return response.text();
        })
            .then((state) => {
              if (this.getCookieItemReward('rewardIsAdded')) {
                this.deleteCookieItemReward('rewardIsAdded');
              }
            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
            });
      }

      async updateItem(data) {
        const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        }).then((response) => {
          return response.text();
        })
            .then((state) => {
              if (this.getCookieItemReward('rewardsAdded') != null) {
                var rewardsAdded =  JSON.parse(this.getCookieItemReward('rewardsAdded'));
                for (let index = 0; index < rewardsAdded.length; index++) {
                  if(rewardsAdded[index].id == data.properties._reward_id) {
                    rewardsAdded.splice(index, 1);
                  }
                }
                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
              }
            })
            .catch(() => {

            });
      }

      updateItemById(lineItemId, newQuantity, newProperties = {}) {
        return this.updateItem({
          id: lineItemId,
          quantity: newQuantity,
          properties: newProperties
        });
      }
    });

customElements.define(
    'drawer-item-reward',
    class DrawerItemReward extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          "updateRewardTrigger" : "[data-item-reward-update]",
          "updateRewardKey" : "itemRewardUpdateKey",
          "updateRewardPanel" : "[data-item-reward-panel]",
          "updateRewardPanelClose" : "[data-item-reward-panel-close]",
          "updateRewardPanelItem" : "[data-item-reward-panel-item]",
          "updateRewardPanelItemId" : "itemRewardPanelItemVariant",
          "updateRewardPanelChange" : "[data-item-reward-panel-change]",
        };

        this.selectors = selectors;

        this.updateRewardTrigger = this.querySelector(this.selectors.updateRewardTrigger);
        if (this.updateRewardTrigger != null) {
          this.updateRewardKey = this.updateRewardTrigger.dataset[this.selectors.updateRewardKey];
        }
        this.updateRewardPanel = this.querySelector(this.selectors.updateRewardPanel);
        this.updateRewardPanelClose = this.querySelector(this.selectors.updateRewardPanelClose);
        this.updateRewardPanelItems = this.querySelectorAll(this.selectors.updateRewardPanelItem);
        this.updateRewardPanelChange = this.querySelector(this.selectors.updateRewardPanelChange);

        this.init();
      }

      async init() {
        const cart = await cartManager.getCart();

        if (this.updateRewardTrigger != null) {
          this.updateRewardTrigger.addEventListener('click', (event) => {
            this.open();
          });
        }

        this.updateRewardPanelClose.addEventListener('click', (event) => {
          this.close();
        });

        this.updateRewardPanelItems.forEach((updateRewardPanelItem) => {
          updateRewardPanelItem.addEventListener('click', (event) => {
            this.selectItem(updateRewardPanelItem);
          });
        });

        var self = this;
        this.updateRewardPanelChange.addEventListener('click', async function(event) {
          self.updateRewardPanelChange.setAttribute('disabled', '');

          localStorage.setItem('rewardAdded', true);

          for (let index = 0; index < self.updateRewardPanelItems.length; index++) {
            const updateRewardPanelItem = self.updateRewardPanelItems[index];
            if (updateRewardPanelItem.classList.contains('active')) {
              var variant_id = updateRewardPanelItem.dataset[self.selectors.updateRewardPanelItemId];
              var properties = {};
              for (let index = 0; index < cart.items.length; index++) {
                if (cart.items[index].key == self.updateRewardKey) {
                  properties = cart.items[index].properties;
                }
              }
              await self.addItem(variant_id, 1, properties);
            }
          }

          await self.updateItemById(self.updateRewardKey, 0);

        });
      }

      open() {
        this.updateRewardPanel.classList.add('active');
      }

      close() {
        this.updateRewardPanel.classList.add('close');
        this.updateRewardPanel.classList.remove('active');
        this.updateRewardPanelChange.removeAttribute('disabled');
        setTimeout(() => this.updateRewardPanel.classList.remove('close'), 1000);
      }

      selectItem(updateRewardPanelItem) {
        this.updateRewardPanelItems.forEach((updateRewardPanelItem) => {
          updateRewardPanelItem.classList.remove('active');
        });
        updateRewardPanelItem.classList.add('active');
      }

      async addItem(variantId, quantity, properties) {
        const result = await fetch(window.root_url+"/cart/add.js?drawer-item-reward", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
          })
        }).then((response) => {
          return response.text();
        })
            .then((state) => {

            })
            .catch(() => {

            });
      }

      async updateItem(data) {
        const result = await fetch(window.root_url+"/cart/change.js?drawer-item-reward", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        }).then((response) => {
          return response.text();
        })
            .then((state) => {
              // this.close();
            })
            .catch(() => {

            });
      }

      updateItemById(lineItemId, newQuantity, newProperties = {}) {
        return this.updateItem({
          id: lineItemId,
          quantity: newQuantity,
          properties: newProperties
        });
      }


    });

customElements.define(
    'drawer-samples',
    class DrawerSample extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          "updateSamplesTrigger" : "[data-item-samples-update]",
          "updateSamplesPanel" : "[data-item-samples-panel]",
          "updateSamplesPanelClose" : "[data-item-samples-panel-close]",
          "updateSamplesPanelItem" : "[data-item-samples-panel-item]",
          "updateSamplesPanelItemId" : "itemSamplesPanelItemVariant",
          "updateSamplesPanelChange" : "[data-item-samples-panel-change]",
          "updateSamplesPanelItemIndex" : "[data-item-samples-panel-item-index]",
          "updateSamplesPanelItemSelecteds" : "[data-item-samples-panel-selected]",
          "updateSamplesPanelCountMax" : "itemSamplesCount",
        };

        this.selectors = selectors;
        this.samples_ids = [];
        this.old_samples_ids = [];

        this.init();

      }

      async init() {

        this.updateSamplesTrigger = this.querySelector(this.selectors.updateSamplesTrigger);
        this.updateSamplesPanel = this.querySelector(this.selectors.updateSamplesPanel);
        this.updateSamplesPanelClose = this.querySelector(this.selectors.updateSamplesPanelClose);
        this.updateSamplesPanelItems = this.querySelectorAll(this.selectors.updateSamplesPanelItem);
        this.updateSamplesPanelChange = this.querySelector(this.selectors.updateSamplesPanelChange);
        this.updateSamplesPanelItemSelecteds = this.querySelectorAll(this.selectors.updateSamplesPanelItemSelecteds);
        this.updateSamplesPanelCountMax = this.updateSamplesTrigger.dataset[this.selectors.updateSamplesPanelCountMax];

        this.samples_ids = [];
        this.old_samples_ids = [];

        const cart = await cartManager.getCart();

        for (let index = 0; index < cart.items.length; index++) {
          if (cart.items[index].properties != null) {
            if ('_is_sample' in cart.items[index].properties) {
              this.old_samples_ids.push({
                variant_id: cart.items[index].variant_id,
                key: cart.items[index].key,
                quantity: cart.items[index].quantity
              });

              this.samples_ids.push({
                variant_id: cart.items[index].variant_id,
                quantity: cart.items[index].quantity
              });
            }
          }
        }

        if (cart.total_price == 0) {
          if (this.old_samples_ids.length != 0) {
            var dataUpdate = {};
            dataUpdate.updates = {};
            for (let index = 0; index < this.old_samples_ids.length; index++) {
              dataUpdate.updates[this.old_samples_ids[index].key] = 0;
            }
            await this.updateItems(dataUpdate);
          }
        }

        this.updateSamplesPanelItemSelecteds.forEach((updateSamplesPanelItemSelected) => {
          updateSamplesPanelItemSelected.innerHTML = this.old_samples_ids.length + "/" + this.updateSamplesPanelCountMax;
        });

        this.updateSamplesTrigger.addEventListener('click', (event) => {
          this.open();
        });

        this.updateSamplesPanelClose.addEventListener('click', (event) => {
          this.close();
        });

        this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
          updateSamplesPanelItem.addEventListener('click', (event) => {
            this.selectItem(updateSamplesPanelItem);
          });
        });

        var self = this;
        this.updateSamplesPanelChange.addEventListener('click', async function(event) {
          self.updateSamplesPanelChange.setAttribute('disabled', '');
          localStorage.setItem('samplesAdded', true);

          if (self.old_samples_ids.length != 0) {
            var dataUpdate = {};
            dataUpdate.updates = {};
            for (let index = 0; index < self.old_samples_ids.length; index++) {
              dataUpdate.updates[self.old_samples_ids[index].key] = 0;
            }
            await self.updateItems(dataUpdate);
          }

          if (self.samples_ids.length != 0) {
            var dataAdd = {};
            dataAdd.items = [];
            for (let index = 0; index < self.samples_ids.length; index++) {
              dataAdd.items.push(
                  {
                    'id': self.samples_ids[index].variant_id,
                    'quantity': 1,
                    'properties': {
                      '_is_sample': true,
                      '_sample_id': self.samples_ids[index].variant_id
                    }
                  }
              );
            }
            await self.addItems(dataAdd);
          }

          self.close();
          await self.renderContents();
        });
      }

      open() {
        this.updateSamplesPanel.classList.add('active');

        if (this.samples_ids.length != 0) {
          for (let index = 0; index < this.samples_ids.length; index++) {
            this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
              if (updateSamplesPanelItem.dataset[this.selectors.updateSamplesPanelItemId] == this.samples_ids[index].variant_id) {
                updateSamplesPanelItem.classList.add('active');
                updateSamplesPanelItem.querySelector(this.selectors.updateSamplesPanelItemIndex).innerHTML = (index + 1);
              }
            });
          }
        }
      }

      close() {
        this.updateSamplesPanel.classList.add('close');
        this.updateSamplesPanel.classList.remove('active');
        this.updateSamplesPanelChange.removeAttribute('disabled');
        setTimeout(() => this.updateSamplesPanel.classList.remove('close'), 1000);
      }

      selectItem(updateSamplesPanelItem) {
        if (updateSamplesPanelItem.classList.contains('active')) {
          updateSamplesPanelItem.classList.remove('active');
          for (let index = 0; index < this.samples_ids.length; index++) {
            if (updateSamplesPanelItem.dataset[this.selectors.updateSamplesPanelItemId] == this.samples_ids[index].variant_id) {
              this.samples_ids.splice(index, 1);
            }
          }

          this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
            if (updateSamplesPanelItem.classList.contains('active')) {
              for (let index = 0; index < this.samples_ids.length; index++) {
                if (updateSamplesPanelItem.dataset[this.selectors.updateSamplesPanelItemId] == this.samples_ids[index].variant_id) {
                  updateSamplesPanelItem.querySelector(this.selectors.updateSamplesPanelItemIndex).innerHTML = (index + 1);
                }
              }
            }
          });

        } else if (this.samples_ids.length <= (this.updateSamplesPanelCountMax - 1)) {
          updateSamplesPanelItem.classList.add('active');
          updateSamplesPanelItem.querySelector(this.selectors.updateSamplesPanelItemIndex).innerHTML = (this.samples_ids.length + 1);
          this.samples_ids.push({
            variant_id: updateSamplesPanelItem.dataset[this.selectors.updateSamplesPanelItemId],
            quantity: 1
          });
        }

        this.updateSamplesPanelItemSelecteds.forEach((updateSamplesPanelItemSelected) => {
          updateSamplesPanelItemSelected.innerHTML = this.samples_ids.length + "/" + this.updateSamplesPanelCountMax;
        });
      }

      async addItems(data) {
        const result = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        }).then((response) => {
          return response.text();
        })
            .then(async function (state) {

            })
            .catch(() => {

            });
      }

      async updateItems(data) {
        const result = await fetch(window.root_url+"/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        }).then((response) => {
          return response.text();
        })
            .then((state) => {

            })
            .catch(() => {

            });
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-item-samples-counter]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-item-samples-images]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-item-samples-panel]',
          },
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          }
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      async renderContents() {
        await fetch('/?sections=cart-drawer-v2', {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        response["cart-drawer-v2"],
                        section.selector,
                    );
                  }
                }
              });
            })
            .catch((error) => {
              console.error('Error:', error);
            });

        this.init();
      }


    });

customElements.define(
    'cart-upsell-discounted',
    class CartUpsellDiscounted extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          "updateUpsellDiscountedTrigger" : "[data-upsell-discounted-update]",
          "updateUpsellDiscountedPanel" : "[data-upsell-discounted-panel]",
          "updateUpsellDiscountedPanelClose" : "[data-upsell-discounted-panel-close]",
          "updateUpsellDiscountedPanelItem" : "[data-upsell-discounted-panel-item]",
          "updateUpsellDiscountedPanelItemId" : "upsellDiscountedPanelItemVariant",
          "updateUpsellDiscountedPanelChange" : "[data-upsell-discounted-panel-change]",
          "updateUpsellDiscountedId" : "upsellDiscountedPanelChange",
          "upsellDiscountedPanelProductParentId" : "upsellDiscountedPanelProductParentId",
        };

        this.selectors = selectors;

        this.init();

      }

      async init() {

        this.updateUpsellDiscountedTrigger = this.querySelector(this.selectors.updateUpsellDiscountedTrigger);
        this.updateUpsellDiscountedPanel = this.querySelector(this.selectors.updateUpsellDiscountedPanel);
        this.updateUpsellDiscountedPanelClose = this.querySelector(this.selectors.updateUpsellDiscountedPanelClose);
        this.updateUpsellDiscountedPanelItems = this.querySelectorAll(this.selectors.updateUpsellDiscountedPanelItem);
        this.updateUpsellDiscountedPanelChange = this.querySelector(this.selectors.updateUpsellDiscountedPanelChange);

        this.upsellDiscounted_ids = [];

        this.updateUpsellDiscountedTrigger.addEventListener('click', (event) => {
          this.open();
        });

        this.updateUpsellDiscountedPanelClose.addEventListener('click', (event) => {
          this.close();
        });

        this.updateUpsellDiscountedPanelItems.forEach((updateUpsellDiscountedPanelItem) => {
          updateUpsellDiscountedPanelItem.addEventListener('click', (event) => {
            this.selectItem(updateUpsellDiscountedPanelItem);
          });
        });

        var self = this;
        this.updateUpsellDiscountedPanelChange.addEventListener('click', async function(event) {
          self.updateUpsellDiscountedPanelChange.setAttribute('disabled', '');
          localStorage.setItem('UpsellDiscountedAdded', true);

          if (self.upsellDiscounted_ids.length != 0) {
            var dataAdd = {};
            dataAdd.items = [];
            for (let index = 0; index < self.upsellDiscounted_ids.length; index++) {
              dataAdd.items.push(
                  {
                    'id': self.upsellDiscounted_ids[index].variant_id,
                    'quantity': 1,
                    'properties': {
                      '_upsell_discounted': true,
                      '_upsell_discounted_id': self.updateUpsellDiscountedPanelChange.dataset[self.selectors.updateUpsellDiscountedId],
                      '_upsell_discounted_product_parent_id': parseInt(self.updateUpsellDiscountedPanelChange.dataset[self.selectors.upsellDiscountedPanelProductParentId])
                    }
                  }
              );
            }
            await self.addItems(dataAdd);
          }

          self.close();
          await self.renderContents();
        });
      }

      open() {
        this.updateUpsellDiscountedPanel.classList.add('active');
      }

      close() {
        this.updateUpsellDiscountedPanel.classList.add('close');
        this.updateUpsellDiscountedPanel.classList.remove('active');
        this.updateUpsellDiscountedPanelChange.removeAttribute('disabled');
        setTimeout(() => this.updateUpsellDiscountedPanel.classList.remove('close'), 1000);
      }

      selectItem(updateUpsellDiscountedPanelItem) {
        this.upsellDiscounted_ids = [];

        this.updateUpsellDiscountedPanelItems.forEach((updateUpsellDiscountedPanelItem) => {
          updateUpsellDiscountedPanelItem.classList.remove('active');
        });

        updateUpsellDiscountedPanelItem.classList.add('active');
        this.upsellDiscounted_ids.push({
          variant_id: updateUpsellDiscountedPanelItem.dataset[this.selectors.updateUpsellDiscountedPanelItemId],
          quantity: 1
        });
      }

      async addItems(data) {
        const result = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        }).then((response) => {
          return response.text();
        })
            .then(async function (state) {

            })
            .catch(() => {

            });
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          }
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      async renderContents() {
        await fetch('/?sections=cart-drawer-v2', {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              this.getSectionsToRender().forEach((section) => {
                if(section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        response["cart-drawer-v2"],
                        section.selector,
                    );
                  }
                }
              });
            })
            .catch((error) => {
              console.error('Error:', error);
            });

        this.init();
      }


    });


customElements.define(
    'shipping-estimate',
    class ShippingEstimate extends HTMLElement {
      constructor() {
        super();

        this.shippingPrice = this.querySelector('[data-shipping-estimate]');
        this.routeCountryAPI = "/browsing_context_suggestions.json";
        this.routeShippingRatesAPI = "/cart/shipping_rates.json";

        this.countries = countries_cart;

        this.init();
      }

      async init() {

        const cart = await cartManager.getCart();
        var findCountry = false;
        var zipCode = null;
        var province = null;

        if (cart.item_count != 0) {
          const countryISO =  await this.getCountry();

          for (let index = 0; index < this.countries.countries.length; index++) {
            if (this.countries.countries[index].code == countryISO) {
              findCountry = true;
              zipCode = this.countries.countries[index].zip_capital;
              if (this.countries.countries[index].provinces.length != 0) {
                province = this.countries.countries[index].provinces[0].name;
              }
            }
          }

          if (findCountry) {
            var request = "?shipping_address[country]=" + countryISO;
            if (zipCode != null) {
              request = request + "&shipping_address[zip]=" + zipCode;
            }
            if (province != null) {
              request = request + "&shipping_address[province]=" + province;
            }

            const shippingRates =  await this.getShippingRates(request);


            var price = shippingRates.shipping_rates[0].price;
            if (!shippingRates.shipping_rates.length || isNaN(price)) return;
            var freeLabel = (window.root_url == "") ? "Free" : "Gratuit";
            price = parseFloat(price) == 0 ? freeLabel : price + '€';

            this.shippingPrice.innerHTML = price;
            this.classList.remove('hidden');
          } else {
            this.classList.add('hidden');
          }
        } else {
          this.classList.add('hidden');
        }
      }

      async getCountry() {
        return await fetch(this.routeCountryAPI, {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              var ISOCountry = JSON.parse(JSON.stringify(response.detected_values.country.handle));
              return ISOCountry;
            })
            .catch((error) => {
              console.error('Error:', error);
            });
      }

      async getShippingRates(request) {
        return await fetch(this.routeShippingRatesAPI + request, {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              return JSON.parse(JSON.stringify(response));
            })
            .catch((error) => {
              console.error('Error:', error);
            });
      }

    },
);